import React, { useState } from "react";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Modal, Row, Spinner, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AccordionSummary, AccordionDetails, Accordion } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import refreshIcon from "../../assets/refresh.png";
import { BsInfoCircle, BsCashCoin } from "react-icons/bs";
import deleteLogo from "../../assets/delete.png";
import ResponsiveTable from "../Common/Table/ResponsiveTable";
import CollapseButton from "../Common/CollapseButton";
import { ImLab } from "react-icons/im";
import CreateKitModal from "../Kit/CreateKitModal";

const CreateKit = ({ clinicalRef, bookingDetails, showKitCreateModal, setShowKitCreateModal, orderKitForBookingFunc }) => {
  return (
    <Accordion defaultExpanded className="mb-4 rounded-none" ref={clinicalRef}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ background: "#0000000F" }}>
        <Card.Header id="cardTitle" className=" w-100 border-0 bg-transparent ">
          <Row id="cardTitle  w-100">
            <Col>Kit/Lab Orders</Col>
          </Row>
        </Card.Header>
      </AccordionSummary>
      <AccordionDetails className="accordionDetails">
        <Card className="Card-wrap-2 border-0 shadow-none ">
          <Card.Body>
            {bookingDetails?.kitIds?.map(id => (
              <React.Fragment key={id}>
                <Row id={`cardRowKitIdLabel_${id}`}>
                  <Col>Kit Id:</Col>
                  <Col>
                    <a href={`${process.env.REACT_APP_BASE_URL}/KitDetails?kitId=${id}`} target="_blank" rel="noopener noreferrer">
                      {id}
                    </a>

                  </Col>
                </Row>
              </React.Fragment>
            ))}
              {showKitCreateModal && (
              <CreateKitModal
                isShowModal={showKitCreateModal}
                onCloseCallBack={() => setShowKitCreateModal(false)}
                onSubmitCallback={orderKitForBookingFunc}
                data={bookingDetails}
              />
            )}

            <Button
              variant="light"
              style={{ background: "#866BD9", color: "white" }}
              onClick={event => {
                setShowKitCreateModal(true);
              }}
            >
              <ImLab />
              <span id="btn-text">&nbsp; &nbsp; Create Kit</span>
            </Button>
          </Card.Body>
        </Card>
      </AccordionDetails>
    </Accordion>
  );
};

export default CreateKit;
